// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editmodal-wrapper{width:15em;height:11em;background-color:silver;top:120px;left:100px;box-shadow:0px 1px 9px 0px rgba(0,0,0,0.75);-webkit-box-shadow:0px 1px 9px 0px rgba(0,0,0,0.75);-moz-box-shadow:0px 1px 9px 0px rgba(0,0,0,0.75)}.editmodal-wrapper .input-wrapper{padding:0px 15px;border:1px solid transparent}.editmodal-wrapper button{width:40%}\n", ""]);
// Exports
module.exports = exports;
